import { action, computed, makeObservable, observable } from "mobx";

export default class SaporeForm {
    constructor(fields = {}, id=null, feature=null, configuration=undefined) {
        // How would this work for fields that depend on others?
        // How would this work for fields that aren't required? We could have OptionalField wrapper
        this._form = fields;
        this._errors = [];
        this._id = id;
        this._formId = null
        this._feature = feature
        this._configuration = configuration

        makeObservable(this, {
            _form: observable,
            _errors: observable,
            _configuration: observable,
            hasErrors: computed,
            isValid: computed,
            clear: action,
        });
    }

    entityId() {
        return this._id
    }

    updateEntityId(id) {
        this._id = id
    }

    formId() {
        return this._formId
    }

    updateFormId(formId) {
        this._formId = formId
    }

    configuration() {
        return this._configuration
    }

    configurationFieldNameMapping() {
        return {}
    }

    get hasErrors() {
        return Object.keys(this._form).some((key) => this._form[key].hasErrors) || this._errors.length > 0;
    }

    get isValid() {
        return Object.keys(this._form).every((key) => this._form[key].isValid);
    }

    getFieldByName(field) {
        return this._form[field];
    }

    getFieldValue(fieldName) {
        return this.getFieldByName(fieldName).value;
    }

    addErrors(errors) {
        this._errors.push(...errors);
    }

    clear() {
        this._errors = [];
        Object.keys(this._form).forEach((key) => this._form[key].clear());
    }

    get values() {
        return Object.keys(this._form).reduce((values, key) => {
            values[key] = this._form[key].value;
            return values;
        }, {});
    }

    setFields(fields) {
        this._form = fields;
    }

    fields() {
        return this._form
    }

    formEntity() {
        return this.values
    }

    formEntityWithFormId() {
        return {...this.formEntity(), formId: this.formId()}
    }

    async updateFieldWithValue(fieldName, value){
        this.getFieldByName(fieldName).updateValue(value)

        if (this._feature && this.hasAllValidValues()) {
            await this._feature.formChanged?.(this.formEntityWithFormId())
        }
    }

    hasAllValidValues() {
        return Object.keys(this._form).every((key) => this._form[key].isValid)
    }

    completionPercentage() {
        const fieldNames = Object.keys(this._form);
        const completedFields = fieldNames.filter(fieldName => {
            const field = this.getFieldByName(fieldName);
            return field.hasValue && field.isValid;
        }).length;
        
        return fieldNames.length > 0 ? Math.round((completedFields / fieldNames.length) * 100) : 0;
    }

    mandatoryCompletionPercentage() {
        const fieldNames = Object.keys(this._form);
        const completedFieldsAmount = fieldNames.filter(fieldName => {
            const field = this.getFieldByName(fieldName);
            return field.hasValue && field.isValid && !field.isOptional;
        }).length;

        const mandatoryFieldNamesAmount = fieldNames.filter(fieldName => {
            const field = this.getFieldByName(fieldName);
            return !field.isOptional;
        }).length;

        if (mandatoryFieldNamesAmount === 0){
            return Math.round(100);
        }

        return mandatoryFieldNamesAmount > 0 ? Math.round((completedFieldsAmount / mandatoryFieldNamesAmount) * 100) : 0;
    }

    isOptional(fieldName) {
        return !(this.configuration().mandatoryFields.includes(this.configurationFieldNameMapping()[fieldName]));
    }

    isReadonly(fieldName) {
        if (!this.configuration()) {return false}
        return this.configuration().readonlyFields.includes(this.configurationFieldNameMapping()[fieldName]);
    }
}